import { DynamicIcon } from 'src/components/DynamicIcon/dynamic-icon';
import { NormalizedSupportPolicy } from 'src/graphql/entities/support-policy/support-policy.utils';
import {
  ESCALATION_URGENCY_DISPLAY_LABELS,
  getEscalationUrgencyDisplay,
} from './escalation-utils';
import { POLICY_CATEGORY_ESCALATION } from './policy-constants';
import { glyphLayoutSx } from './policy-glyph.styles';
import { getSeverityForType } from './policy-severity';
import { PolicySeverityGlyph } from './policy-severity-glyph';

const GLYPH_SIZE = 13;

interface PolicyGlyphProps {
  policy: Pick<NormalizedSupportPolicy, 'category' | 'type' | 'urgencyLevel'>;
  /** Extra top offset, to follow a padded text block down. */
  extraOffsetY?: string;
}

/**
 * The leading icon on a policy row. Escalation policies show their urgency, so
 * the front line reads how fast to move; every other category shows how firm the
 * rule is. Both policy surfaces render this, so the two never drift apart.
 */
export const PolicyGlyph = ({ policy, extraOffsetY }: PolicyGlyphProps) => {
  if (policy.category !== POLICY_CATEGORY_ESCALATION) {
    return (
      <PolicySeverityGlyph
        severity={getSeverityForType(policy.type)}
        extraOffsetY={extraOffsetY}
      />
    );
  }

  const { icon, library, color } = getEscalationUrgencyDisplay(policy.urgencyLevel);

  return (
    <DynamicIcon
      name={icon}
      library={library}
      size={GLYPH_SIZE}
      aria-hidden
      data-testid="policy-urgency-glyph"
      title={ESCALATION_URGENCY_DISPLAY_LABELS[policy.urgencyLevel ?? '']}
      sx={{ ...glyphLayoutSx(extraOffsetY), color }}
    />
  );
};
